// src/services/AdminContactService.js
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL ,
});

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});


export const listContacts = async ({ page = 1, limit = 20, q = "" } = {}) => {
  const res = await API.get(`/admin/contacts`, {
    params: { page, limit, q },
  });
  
  return res.data;
};

export const getContact = async (id) => {
  const res = await API.get(`/admin/contacts/${id}`);
  return res.data;
};

export const replyContact = async (id, message) => {
  const res = await API.post(`/admin/contacts/${id}/reply`, { message });
  return res.data;
};
